// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"landingLayout_pageWrapper__hC_GP","fopageWrappernt":"landingLayout_fopageWrappernt__2JWO1","font":"landingLayout_font__35gOc"};